import {
  FC,
  MouseEventHandler,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react';

import { StyledAudioCallModal } from './styled';
import { getSmallScreenPositions } from '../_utils';

interface IProps {
  isFullScreen: boolean;
  children: ReactNode;
}

const Draggable: FC<IProps> = ({ isFullScreen, children }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [position, setPosition] = useState(getSmallScreenPositions());
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!isFullScreen) {
      setPosition(getSmallScreenPositions());
    }
  }, [isFullScreen]);

  const handleMouseDown: MouseEventHandler<HTMLDivElement> = e => {
    if (isFullScreen || !ref.current) {
      return;
    }

    setIsDragging(true);

    const rect = ref.current.getBoundingClientRect();

    setOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseMove: MouseEventHandler<HTMLDivElement> = e => {
    if (!isDragging) return;

    setPosition({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y
    });
  };

  useEffect(() => {
    const handleMouseUp = () => {
      setIsDragging(false);
    };

    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsDragging(false);
      setPosition(getSmallScreenPositions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <StyledAudioCallModal
      ref={ref}
      style={
        isFullScreen
          ? {}
          : {
              top: `${position.y}px`,
              left: `${position.x}px`
            }
      }
      $isFullScreen={isFullScreen}
      $isDragging={isDragging}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
    >
      {children}
    </StyledAudioCallModal>
  );
};

export default Draggable;
